import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconAiBotMain = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 34,
	height: 32,
	viewBox: "0 0 34 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group 5308",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 223 (Stroke)",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M18.4163 7.49609L18.4163 11.7461L15.583 11.7461L15.583 7.49609L18.4163 7.49609Z",
				fill: "#3730A3"
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle 34624199",
				x: 4.25,
				y: 10.332,
				width: 25.5,
				height: 21.25,
				rx: 8.5,
				fill: "#EEF2FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Union",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12.75 13.1654H21.25C24.3796 13.1654 26.9167 15.7024 26.9167 18.832V23.082C26.9167 26.2116 24.3796 28.7487 21.25 28.7487H12.75C9.62117 28.7487 7.0846 26.2129 7.08333 23.0844C7.08333 23.0836 7.08333 23.0828 7.08333 23.082V18.832C7.08333 18.8312 7.08333 18.8305 7.08333 18.8297C7.0846 15.7011 9.62117 13.1654 12.75 13.1654ZM5.38312 14.589C6.85182 12.0445 9.60092 10.332 12.75 10.332H21.25C24.3991 10.332 27.1482 12.0445 28.6169 14.589C31.6148 14.7367 34 17.2142 34 20.2487C34 23.0507 31.9664 25.3776 29.2946 25.8342C28.1509 29.1779 24.9812 31.582 21.25 31.582H12.75C9.01878 31.582 5.84907 29.1779 4.70543 25.8342C2.03364 25.3776 0 23.0507 0 20.2487C0 17.2142 2.38524 14.7367 5.38312 14.589Z",
				fill: "#818CF8"
			}),
			/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse 56",
				cx: 17,
				cy: 4.66406,
				r: 4.25,
				fill: "#6366F1"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 224 (Stroke)",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M14.1667 17.4141C14.9491 17.4141 15.5833 18.0483 15.5833 18.8307L15.5833 21.6641C15.5833 22.4465 14.9491 23.0807 14.1667 23.0807C13.3843 23.0807 12.75 22.4465 12.75 21.6641L12.75 18.8307C12.75 18.0483 13.3843 17.4141 14.1667 17.4141Z",
				fill: "#312E81"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 225 (Stroke)",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19.8337 17.4141C20.6161 17.4141 21.2503 18.0483 21.2503 18.8307L21.2503 21.6641C21.2503 22.4465 20.6161 23.0807 19.8337 23.0807C19.0513 23.0807 18.417 22.4465 18.417 21.6641L18.417 18.8307C18.417 18.0483 19.0513 17.4141 19.8337 17.4141Z",
				fill: "#312E81"
			})
		]
	})
});
export default SvgIconAiBotMain;
